<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  SYNTHETIC_GRAPHITE,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_SYNTHETIC_GRAPHITE,
} from '~/constants/services/constants'
import syntheticGraphiteData from '~/constants/price-assessments/unauthorized/synthetic-graphite'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
    Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_SYNTHETIC_GRAPHITE
const data = {
  product: SYNTHETIC_GRAPHITE,
  productData: syntheticGraphiteData,
  subscription,
}

/*-------------------------------------
    SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${SYNTHETIC_GRAPHITE.name} Prices`,
})
useHead(seo)
</script>
